// Product brief for New York Life Asset Flex. See cmTwo.ts for the format intent.

export const nylAssetFlexBrief = `**NYL Asset Flex** — reimbursement hybrid life with an LTC rider.

Pool model — two pools, drawn in order:
- **Acceleration** is the \`base_pool\`, drawn FIRST.
- **Extension of Benefits (EOB)** is the \`eob\` column, drawn only after the
  Acceleration pool is exhausted.
- Each pool inflates on its **own ACIO rate**, compounding at the policy
  anniversary (\`base_pool_inflation\` for Acceleration, \`eob_pool_inflation\` for
  EOB). These rates are **illustration-specific and may differ**: some Asset Flex
  illustrations apply the ACIO only to the EOB monthly benefit (the Acceleration
  "Monthly Benefit for LTC" stays level at 0%), while others apply it to both
  layers. Never assume the two rates match — read each from the illustration.
  Each pool's monthly cap inflates on that pool's own ACIO rate.
- At-issue pools prefer Monthly Benefit × printed duration months when the
  duration fields are present. Printed ACIO dollar pools can be forward-inflated,
  so duration-derived dollars are the trustworthy at-issue base; legacy policies
  without duration fields fall back to stored dollar pools.

Payout model — **reimbursement only**:
- Pays min(eligible cost, pro-rated monthly cap), drawing Acceleration then EOB.
  Care cost above the cap is out-of-pocket; there is no cash-indemnity election,
  so \`payout\` never exceeds the month's care cost and indemnity surplus is $0.

Death benefit:
- Flat Face Amount, reduced **in direct proportion to the remaining
  Acceleration pool** as it is drawn down (carrier p.2 fn.2; close DB =
  open DB × pool-after / pool-before — P2-12),
  floored at the Residual DB (10% of initial Face on the mapped illustration).
  EOB drawdown does NOT reduce it, and ACIO does not increase the Face. Remaining
  DB at the horizon is a non-LTC return.

Elimination period:
- **No retroactive WP lump.** Elimination-period days are out-of-pocket
  (\`in-wp\` rows).

Things to eyeball:
- Acceleration depletes before any EOB drawdown.
- Each pool ceiling grows on its own ACIO rate; the Acceleration layer may be
  level (0%) while EOB inflates, or both may inflate — whatever the illustration
  shows. The displayed monthly benefit for each layer is the driver of its pool.
- Death benefit falls only with Acceleration drawdown, never EOB drawdown.
- Indemnity surplus is $0 — this is a pure reimbursement product.
`;
